import React from "react";
import { theme } from "../theme";
import { Link } from 'react-router-dom';

const Footer = ({ compact = false }) => {
  return (
    <footer style={{
      ...styles.footer,
      padding: compact ? '12px 16px' : '20px 16px',
    }}>
      <div style={styles.inner}>
        <span style={styles.copy}>© Demiplie Doces LTDA · CNPJ 52.742.065/0001-06</span>
        <span style={styles.sep}>·</span>
        <a href="mailto:maira@bolospersonalizados.com.br" style={styles.link}>
          maira@bolospersonalizados.com.br
        </a>
        <span style={styles.sep}>·</span>
        {/* Politica no rodape: as lojas pedem o link e o revisor precisa
            encontrar sem procurar. */}
        <Link to="/privacidade" style={styles.link}>Privacidade</Link>
        <a href="https://status.metria.demiplie.com.br" target="_blank" rel="noreferrer" style={styles.link}>
          Status
        </a>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    width: '100%',
    background: 'transparent',
    borderTop: `1px solid ${theme.colors.borderLight || '#EDE5E0'}`,
    marginTop: 32,
  },
  inner: {
    maxWidth: 1100, margin: '0 auto',
    display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
    alignItems: 'center', gap: 8,
    fontSize: 12, color: theme.colors.textMuted || '#9C8B8B',
    textAlign: 'center',
  },
  copy: { whiteSpace: 'nowrap' },
  sep: { color: theme.colors.borderLight || '#D9CCC4' },
  link: {
    color: theme.colors.textSecondary || '#7A6868',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
};

export default Footer;
